require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./scribbling-about-the-phone-messenger-component.json") })
        }
      }, "path---scribbling-about-the-phone-messenger-component");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---scribbling-about-the-phone-messenger-component!./.cache/json/scribbling-about-the-phone-messenger-component.json
// module id = 563
// module chunks = 231608221292675